import { FunctionComponent, ReactElement, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Domain } from '../../constants/constants';
import { useStep } from '../../hooks/useStep';
import { store } from '../../store/store';
import { ICON, SideMenuData, SideMenuDataSecondaryItem, SIDEMENUSTATE, StepFamily } from '../../utils/DsType';
import { isFamilyWithStep, retrieveFamilyKey, Step, StepModel, steps, stepsLocataire } from '../../utils/Steps';
import logoCTLM from '../assets/cetelemLogo.svg';
import logoCM from '../assets/creditModerneLogo.svg';
import credito from '../assets/credito.png';

const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  a {
    margin-bottom: 8px;
    text-decoration: none;
  }
`;

const CreditoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  img {
    height: 308px;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 60px;
  img {
    width: 100%;
  }
`;

const Container = styled.div`
  display: flex;
`;
interface NavProps {
  currentStep: Step;
}

export const NavContainer: FunctionComponent<NavProps> = ({ currentStep }): ReactElement => {
  const {
    state: { housing },
    logementValue,
  } = useContext(store);
  const [actualSteps, setactualSteps] = useState(steps);

  const host = window.location.hostname;
  const logo = host.includes(Domain.CTLM) || host.includes(Domain.LOCAL) ? logoCTLM : logoCM;

  const getNavStateForStep = (currentStepOrder: number, itemOrder: number): SIDEMENUSTATE => {
    return currentStepOrder === itemOrder
      ? SIDEMENUSTATE.ENABLED
      : itemOrder < currentStepOrder
      ? SIDEMENUSTATE.SELECTED
      : SIDEMENUSTATE.DISABLED;
  };
  const getUpdatedNavStateForFamily = (
    currentStep: StepModel,
    givenFamily: string,
    updatedItems: SideMenuDataSecondaryItem[],
  ): SIDEMENUSTATE => {
    if (currentStep.family === givenFamily) return SIDEMENUSTATE.ENABLED;
    const isSelected = updatedItems.reduce(
      (prev: boolean, item: SideMenuDataSecondaryItem) => (item.state === SIDEMENUSTATE.SELECTED ? true : prev),
      false,
    );
    if (isSelected) return SIDEMENUSTATE.SELECTED;

    return SIDEMENUSTATE.DISABLED;
  };
  const getUpdatedNavStateForStep = (
    currentStep: StepModel,
    items: SideMenuDataSecondaryItem[],
  ): SideMenuDataSecondaryItem[] => {
    const result: SideMenuDataSecondaryItem[] = [];
    for (let i = 0; i < items.length; i++) {
      result[i] = { ...items[i], state: getNavStateForStep(currentStep.order, items[i].order) };
    }
    return result;
  };

  const initNavConfig = (loadedStep = steps): SideMenuData => {
    const stepWithState: (StepModel & { state: SIDEMENUSTATE })[] = loadedStep.map((item, index) => ({
      ...item,
      state: SIDEMENUSTATE.DISABLED,
    }));

    return stepWithState.reduce(
      (previous: SideMenuData, { family, navLabel, order, state }: StepModel & { state: SIDEMENUSTATE }) =>
        previous[family]
          ? {
              ...previous,
              [family]: {
                ...previous[family],
                items: [...previous[family]!.items, { label: navLabel, state, order }],
              },
            }
          : {
              ...previous,
              [family]: {
                state: SIDEMENUSTATE.DISABLED,
                icon: ICON[retrieveFamilyKey(family)!] ?? ICON.ABOUT,
                displaySecondaryMenu: isFamilyWithStep(family),
                items: [{ label: navLabel, state, order }],
              },
            },
      {} as SideMenuData,
    );
  };

  const { stepData } = useStep(currentStep);
  const [navConfig, setNavConfig] = useState<SideMenuData>(initNavConfig());

  const getConfigWithUpdatedState = (stepData: StepModel): SideMenuData => {
    const result = {} as SideMenuData;
    for (const label in navConfig) {
      const items: SideMenuDataSecondaryItem[] = navConfig[label as StepFamily].items || [];
      const updatedItems: SideMenuDataSecondaryItem[] = getUpdatedNavStateForStep(stepData, items);
      result[label as StepFamily] = {
        ...navConfig[label as StepFamily],
        ...{
          state: getUpdatedNavStateForFamily(stepData, label, updatedItems),
          items: updatedItems,
        },
      };
    }
    return result;
  };

  useEffect(() => {
    setTimeout(() => setNavConfig(getConfigWithUpdatedState(stepData)), 300);
  }, [stepData]);
  useEffect(() => {
    if (housing?.housingCode === 'L') {
      setNavConfig(initNavConfig(stepsLocataire));
    } else {
      setNavConfig(initNavConfig(steps));
    }
  }, [housing]);

  return (
    <Container>
      <side-menu
        config={JSON.stringify(navConfig)}
        selected-secondary-item={stepData.navLabel}
        property-evaluate-to-select-item="label"
      >
        <CreditoContainer slot="logo">
          <img src={credito} />
        </CreditoContainer>

        <LogoContainer slot="sellerLogo">
          <img src={logo} />
        </LogoContainer>
      </side-menu>
    </Container>
  );
};
